module.exports = __webpack_public_path__ + "558d1bb4c11eb359689bc0b7e22b434a.png";